import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);

Vue.config.productionTip = false;

import "@/style/common.scss";

import Bridge from "./bridge/bridge.js";
Vue.prototype.$bridge = Bridge;

import http from "./server/http";
Vue.prototype.$http = http;

import utils from "./utils";
Vue.prototype.$utils = utils;

new Vue({
  router,
  store,
  methods: {
    ...utils,
  },
  render: (h) => h(App),
}).$mount("#app");
